/* =====================================================================================================================
   batida-v7-kreator.js: the cake creator on "Tort personalizowany" (new batida.pl, prototype _44 view "TortProjekt";
   sections/batida-v7-kreator-form.liquid, templates/product.kreator.json).
   Same functions as the old cake wizard (assets/batida-cake-wizard.js, BS-112) in the new look:
   - 7 steps + thank-you, progress dots (an earlier step can be clicked), live "Twój tort" summary;
   - the same validation per step, the same Cloudinary upload (unsigned preset, max N photos, 10 MB), the same NIP
     lookup (Ministerstwo Finansów "Biała Lista", CORS-open, no key);
   - sending: fills the hidden Shopify contact form (#v7tp-send, same contact[...] names + the same e-mail body as the
     old wizard) and requestSubmit()s it. That hidden form is the only one registered with Shopify.captcha.protect()
     (the visible fields are not a form, so no submit event can post an unfinished enquiry - see the captcha trap note).
     Shopify comes back with ?contact_posted=true -> the thank-you step.
   Config + texts: the JSON in [data-v7tp-cfg] (section settings).
   ===================================================================================================================== */
(function () {
  'use strict';

  /* hero button "Zaprojektuj swój tort ↓" (other section) -> smooth scroll to the creator.
     Clarity 5e (Aleksandra 5.10): people tapped the button and the "Twój tort" summary and saw nothing happen (the scroll
     was short or under the header). Now the scroll lands on the open step just below the header, the step gets a short
     pink highlight and its first field the focus; a tap on the "Twój tort" summary does the same. Revert: git. */
  function goToForm() {
    var box = document.getElementById('kreator');
    if (!box) return false;
    var step = box.querySelector('[data-v7tp-step]:not([hidden])') || box;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hdr = document.querySelector('.theme__header');
    var off = (hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0) + 16;
    window.scrollTo({ top: Math.max(0, step.getBoundingClientRect().top + window.pageYOffset - off), behavior: reduce ? 'auto' : 'smooth' });
    step.classList.remove('v7tp-flash'); void step.offsetWidth; step.classList.add('v7tp-flash');
    setTimeout(function () {
      var f = step.querySelector('button, input, select, textarea');
      if (f) { try { f.focus({ preventScroll: true }); } catch (er) {} }
    }, reduce ? 0 : 600);
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-v7tp-go], .v7tp-sum');
    if (!a) return;
    if (a.classList.contains('v7tp-sum') && e.target.closest('a, button, input')) return;
    if (goToForm()) e.preventDefault();
  });

  function init() {
    var root = document.querySelector('[data-v7tp]');
    if (!root || root.hasAttribute('data-v7tp-ready')) return;
    root.setAttribute('data-v7tp-ready', '1');

    var C = {};
    try { C = JSON.parse(root.querySelector('[data-v7tp-cfg]').textContent); } catch (err) { C = {}; }
    var T = C.t || {};
    var LOC = C.locale || 'pl';
    var MIN = +C.minPor || 15, MAX = +C.maxPor || 150, STEP = +C.stepPor || 5;
    var MAXPH = +C.maxPhotos || 3;
    var EMPTY = T.empty || '-';

    function $(sel, ctx) { return (ctx || root).querySelector(sel); }
    function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
    function txt(el, s) { if (el) el.textContent = s; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function isoDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

    /* ---------- state (same fields as the old wizard) ---------- */
    var S = {
      occasion: '', portions: MIN, flavour: '', styles: [], desc: '', inscription: '',
      photos: [], photoLink: '', date: null, fulfil: 'pickup', butik: '', address: '', win: '',
      name: '', phone: '', email: '', invoice: false,
      inv: { nip: '', name: '', street: '', no: '', zip: '', city: '' }
    };
    var step = 0, uploading = false, sending = false;

    var panels = $all('[data-v7tp-step]');
    var dots = $all('[data-v7tp-dot]');
    var fill = $('[data-v7tp-fill]');
    var btnBack = $('[data-v7tp-back]');
    var btnNext = $('[data-v7tp-nextbtn]');
    var nav = $('[data-v7tp-nav]');
    var errBox = $('[data-v7tp-err]');
    var card = $('[data-v7tp-card]');

    /* ---------- spam check: the hidden sender form only (BS-112 pattern) ---------- */
    var sendForm = document.getElementById('v7tp-send');
    var sendArmed = false;
    if (sendForm && window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(sendForm, function () { if (sendArmed) sendForm.submit(); });
    }

    /* ---------- summary ---------- */
    function lbl(sel, fb) { var b = $(sel); return b ? (b.getAttribute('data-v7tp-label') || fb) : fb; }   // the chip's visible label (the value stays Polish for the e-mail)
    function setSum(key, v) {
      var el = $('[data-v7tp-sum="' + key + '"]');
      if (!el || el.textContent === v) return;
      el.textContent = v;
      el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
    }
    function dateLabel(d) {
      try { return d.toLocaleDateString(LOC, { weekday: 'long', day: 'numeric', month: 'long' }); }
      catch (e) { return isoDate(d); }
    }
    function summary() {
      setSum('occ', (S.occasion && lbl('[data-v7tp-occ].is-on', S.occasion)) || EMPTY);
      setSum('por', S.portions + ' ' + (T.unit || ''));
      setSum('fl', (S.flavour && lbl('[data-v7tp-fl].is-on', S.flavour)) || EMPTY);
      var look = $all('[data-v7tp-st].is-on').map(function (b) { return b.getAttribute('data-v7tp-label') || b.getAttribute('data-v7tp-st'); }).join(', ');
      if (!look && S.desc.trim()) look = S.desc.trim().length > 40 ? S.desc.trim().slice(0, 40) + '…' : S.desc.trim();
      setSum('st', look || EMPTY);
      setSum('nap', S.inscription ? '„' + S.inscription + '”' : EMPTY);
      var ins = '';
      if (S.photos.length) ins = S.photos.length + ' ' + (T.photosUnit || '');
      if (S.photoLink.trim()) ins += (ins ? ' + ' : '') + (T.link || 'link');
      setSum('ins', ins || EMPTY);
      setSum('date', S.date ? dateLabel(S.date) : EMPTY);
      setSum('where', S.fulfil === 'pickup' ? (S.butik || EMPTY) : ((T.delivery || '') + (S.win ? ' · ' + S.win : '')));
    }

    /* ---------- validation per step (as the old wizard) ---------- */
    function isValidNip(nip) {
      nip = String(nip || '').replace(/[\s\-]/g, '');
      if (!/^\d{10}$/.test(nip)) return false;
      var w = [6, 5, 7, 2, 3, 4, 5, 6, 7], sum = 0;
      for (var i = 0; i < 9; i++) sum += parseInt(nip.charAt(i), 10) * w[i];
      var c = sum % 11;
      return c !== 10 && c === parseInt(nip.charAt(9), 10);
    }
    /* returns '' when the step is fine, else the message + marks the fields */
    function stepError(i) {
      $all('.v7tp-f.is-bad').forEach(function (f) { f.classList.remove('is-bad'); });
      function bad(sel) { var f = $(sel); if (f) f.classList.add('is-bad'); }
      switch (i) {
        case 0: return S.occasion ? '' : T.errOcc;
        case 1: return S.portions >= MIN ? '' : T.errOcc;
        case 2: return S.flavour ? '' : T.errFl;
        case 3: if (S.styles.length > 0 || S.desc.trim().length > 2) return ''; bad('[data-v7tp-desc]'); return T.errLook;
        case 4: return uploading ? T.errUpload : '';
        case 5:
          if (!S.date) return T.errDate;
          if (S.fulfil === 'pickup') return S.butik ? '' : T.errPickup;
          if (S.address.trim().length > 5 && S.win) return '';
          if (S.address.trim().length <= 5) bad('[data-v7tp-address]');
          return T.errDelivery;
        case 6:
          var okName = S.name.trim().length > 2;
          var okMail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(S.email.trim());
          var okPhone = S.phone.replace(/\D/g, '').length >= 9;
          if (!okName) bad('[data-v7tp-name]');
          if (!okPhone) bad('[data-v7tp-phone]');
          if (!okMail) bad('[data-v7tp-email]');
          if (!okName || !okMail || !okPhone) return T.errData;
          if (S.invoice) {
            var okNip = isValidNip(S.inv.nip), okCo = S.inv.name.trim().length > 1;
            if (!okNip) bad('[data-v7tp-inv-nip]');
            if (!okCo) bad('[data-v7tp-inv-name]');
            if (!okNip || !okCo) return T.errNip;
          }
          return '';
      }
      return '';
    }
    function showErr(msg) {
      if (!errBox) return;
      errBox.hidden = !msg;
      txt(errBox, msg || '');
    }
    function shake(el) {
      if (!el) return;
      el.classList.remove('v7tp-shake'); void el.offsetWidth; el.classList.add('v7tp-shake');
    }

    /* ---------- navigation ---------- */
    function go(n, focus) {
      step = Math.max(0, Math.min(7, n));
      panels.forEach(function (p) { p.hidden = +p.getAttribute('data-v7tp-step') !== step; });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-cur', i === step);
        d.classList.toggle('is-done', i < step);
        if (i === step) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current');
      });
      if (fill) fill.style.width = (Math.min(step, 6) / 6 * 100) + '%';
      btnBack.style.visibility = step > 0 && step < 7 ? 'visible' : 'hidden';
      nav.hidden = step === 7;
      txt(btnNext, step === 6 ? T.send : T.next);
      showErr('');
      if (step === 5) renderCal();
      if (focus) {
        var r = card.getBoundingClientRect();
        if (r.top < 70) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var h = panels[step] && panels[step].querySelector('h3, [data-v7tp-done]');
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      }
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var s = +d.getAttribute('data-v7tp-dot');
        if (s < step && step < 7) go(s, true);
      });
    });
    btnBack.addEventListener('click', function () { if (step > 0 && step < 7) go(step - 1, true); });
    btnNext.addEventListener('click', function () {
      if (sending) return;
      var msg = stepError(step);
      if (msg) {
        showErr(msg);
        shake(step === 0 ? $('[data-v7tp-occs]') : btnNext);
        return;
      }
      if (step === 6) { send(); return; }
      go(step + 1, true);
    });

    /* ---------- 1. occasion: a click goes straight on ---------- */
    $all('[data-v7tp-occ]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.occasion = b.getAttribute('data-v7tp-occ');
        $all('[data-v7tp-occ]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        summary(); showErr('');
        setTimeout(function () { if (step === 0) go(1, true); }, 250);
      });
    });

    /* ---------- 2. portions ---------- */
    var porEl = $('[data-v7tp-por]'), minus = $('[data-v7tp-minus]'), plus = $('[data-v7tp-plus]');
    function setPor(n) {
      n = Math.round(+n);
      if (isNaN(n)) n = MIN;
      S.portions = Math.max(MIN, Math.min(MAX, n));
      txt(porEl, String(S.portions));
      if (minus) minus.disabled = S.portions <= MIN;
      if (plus) plus.disabled = S.portions >= MAX;
      $all('[data-v7tp-q]').forEach(function (c) {
        var on = +c.getAttribute('data-v7tp-q') === S.portions;
        c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      summary();
    }
    if (minus) minus.addEventListener('click', function () { setPor(S.portions - STEP); });
    if (plus) plus.addEventListener('click', function () { setPor(S.portions + STEP); });
    $all('[data-v7tp-q]').forEach(function (c) { c.addEventListener('click', function () { setPor(c.getAttribute('data-v7tp-q')); }); });

    /* ---------- 3. flavour ---------- */
    $all('[data-v7tp-fl]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.flavour = b.getAttribute('data-v7tp-fl');
        $all('[data-v7tp-fl]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        summary(); showErr('');
      });
    });

    /* ---------- 4. look (several styles) ---------- */
    $all('[data-v7tp-st]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-v7tp-st'), i = S.styles.indexOf(v);
        if (i === -1) S.styles.push(v); else S.styles.splice(i, 1);
        b.classList.toggle('is-on', i === -1); b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
        summary(); showErr('');
      });
    });
    var descEl = $('[data-v7tp-desc]'), napisEl = $('[data-v7tp-napis]');
    if (descEl) descEl.addEventListener('input', function () { S.desc = descEl.value; descEl.classList.remove('is-bad'); summary(); });
    if (napisEl) napisEl.addEventListener('input', function () { S.inscription = napisEl.value; summary(); });

    /* ---------- 5. inspirations: Cloudinary upload (as the old wizard) ---------- */
    var fileInput = $('[data-v7tp-file]'), drop = $('[data-v7tp-drop]'), dropH = $('[data-v7tp-droph]');
    var upMsg = $('[data-v7tp-upmsg]'), thumbs = $('[data-v7tp-thumbs]');
    var dropHText = dropH ? dropH.textContent : '';
    var hasCloud = !!(C.cloud && C.preset);
    if (!hasCloud) { var upWrap = $('[data-v7tp-upwrap]'); if (upWrap) upWrap.hidden = true; }
    function upNote(msg) { if (!upMsg) return; upMsg.hidden = !msg; txt(upMsg, msg || ''); }
    function renderThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      S.photos.forEach(function (p, idx) {
        var d = document.createElement('div'); d.className = 'v7tp-thumb';
        var img = document.createElement('img'); img.alt = ''; img.src = p.replace('/upload/', '/upload/w_144,h_144,c_fill/');
        var x = document.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', '×');
        x.addEventListener('click', function () { S.photos.splice(idx, 1); renderThumbs(); summary(); });
        d.appendChild(img); d.appendChild(x); thumbs.appendChild(d);
      });
    }
    function uploadFile(file) {
      if (S.photos.length >= MAXPH) { upNote(T.photoTooMany); return Promise.resolve(); }
      if (file.size > 10 * 1024 * 1024) { upNote(T.photoTooBig); return Promise.resolve(); }
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', C.preset);
      return fetch('https://api.cloudinary.com/v1_1/' + C.cloud + '/image/upload', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.secure_url) { if (S.photos.length < MAXPH) S.photos.push(j.secure_url); } else upNote(T.photoErr); })
        .catch(function () { upNote(T.photoErr); });
    }
    function handleFiles(list) {
      var files = Array.prototype.slice.call(list || []).filter(function (f) { return /^image\//.test(f.type); });
      if (!files.length || uploading) return;
      var room = MAXPH - S.photos.length;
      upNote(files.length > room ? T.photoTooMany : '');
      files = files.slice(0, Math.max(0, room));
      if (!files.length) return;
      uploading = true;
      if (drop) drop.classList.add('is-busy');
      txt(dropH, T.uploading || dropHText);
      /* one after another, so the limit holds */
      files.reduce(function (p, f) { return p.then(function () { return uploadFile(f); }); }, Promise.resolve()).then(function () {
        uploading = false;
        if (drop) drop.classList.remove('is-busy');
        txt(dropH, dropHText);
        if (fileInput) fileInput.value = '';
        renderThumbs(); summary();
        if (step === 4) showErr('');
      });
    }
    if (fileInput) fileInput.addEventListener('change', function () { handleFiles(fileInput.files); });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { if (e.dataTransfer) handleFiles(e.dataTransfer.files); });
    }
    var urlEl = $('[data-v7tp-url]');
    if (urlEl) urlEl.addEventListener('input', function () { S.photoLink = urlEl.value; summary(); });

    /* ---------- 6. date + pickup / delivery ---------- */
    function parseDays(s) {
      var out = [];
      String(s || '').split(',').forEach(function (tok) {
        var p = tok.trim().split('.');
        if (p.length < 2) return;
        var d = parseInt(p[0], 10), m = parseInt(p[1], 10), y = p[2] ? parseInt(p[2], 10) : 0;
        if (!d || !m) return;
        out.push(y ? y + '-' + m + '-' + d : m + '-' + d);
      });
      return out;
    }
    var CLOSED = parseDays(C.closed), CLOSED_DEL = parseDays(C.closedDelivery);
    function slots(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
    var WIN_WEEK = slots(C.slotsWeek), WIN_WEEKEND = slots(C.slotsWeekend);
    if (!WIN_WEEKEND.length) WIN_WEEKEND = WIN_WEEK;
    function earliest() {
      var e = new Date(Date.now() + (+C.leadH || 120) * 3600 * 1000);
      e.setHours(0, 0, 0, 0);
      return e;
    }
    function isShut(dt) {
      var k = (dt.getMonth() + 1) + '-' + dt.getDate(), ky = dt.getFullYear() + '-' + k;
      if (dt < earliest()) return true;
      if (C.sundays && dt.getDay() === 0) return true;
      if (CLOSED.indexOf(k) >= 0 || CLOSED.indexOf(ky) >= 0) return true;
      if (S.fulfil === 'delivery' && (CLOSED_DEL.indexOf(k) >= 0 || CLOSED_DEL.indexOf(ky) >= 0)) return true;
      return false;
    }
    var minMonth = earliest(); minMonth.setDate(1);
    var maxMonth = new Date(minMonth); maxMonth.setMonth(maxMonth.getMonth() + 12);
    var view = new Date(minMonth);
    var daysBox = $('[data-v7tp-days]'), monEl = $('[data-v7tp-mon]'), prevB = $('[data-v7tp-prev]'), nextB = $('[data-v7tp-next]');
    function monthLabel(d) {
      var s;
      try { s = new Intl.DateTimeFormat(LOC, { month: 'long', year: 'numeric' }).format(d); } catch (e) { s = (d.getMonth() + 1) + '.' + d.getFullYear(); }
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
    function renderCal() {
      if (!daysBox) return;
      txt(monEl, monthLabel(view));
      if (prevB) prevB.disabled = view <= minMonth;
      if (nextB) nextB.disabled = view >= maxMonth;
      daysBox.innerHTML = '';
      var first = (view.getDay() + 6) % 7; /* Monday first, like the design */
      var n = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var i = 0; i < first; i++) daysBox.appendChild(document.createElement('span'));
      for (var k = 1; k <= n; k++) {
        (function (dt) {
          var b = document.createElement('button');
          b.type = 'button'; b.textContent = dt.getDate();
          b.disabled = isShut(dt);
          b.setAttribute('aria-label', dateLabel(dt));
          if (S.date && dt.getTime() === S.date.getTime()) { b.className = 'is-on'; b.setAttribute('aria-pressed', 'true'); }
          b.addEventListener('click', function () { S.date = dt; renderWins(); renderCal(); summary(); showErr(''); });
          daysBox.appendChild(b);
        })(new Date(view.getFullYear(), view.getMonth(), k));
      }
    }
    if (prevB) prevB.addEventListener('click', function () { if (view > minMonth) { view.setMonth(view.getMonth() - 1); renderCal(); } });
    if (nextB) nextB.addEventListener('click', function () { if (view < maxMonth) { view.setMonth(view.getMonth() + 1); renderCal(); } });

    /* delivery windows: Mon-Fri list, Sat/Sun list (settings) */
    var winsBox = $('[data-v7tp-wins]');
    function renderWins() {
      if (!winsBox) return;
      var list = WIN_WEEK;
      if (S.date && (S.date.getDay() === 6 || S.date.getDay() === 0)) list = WIN_WEEKEND;
      if (list.indexOf(S.win) === -1) S.win = '';
      winsBox.innerHTML = '';
      list.forEach(function (w) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'v7tp-chip' + (w === S.win ? ' is-on' : ''); b.textContent = w;
        b.setAttribute('aria-pressed', w === S.win ? 'true' : 'false');
        b.addEventListener('click', function () { S.win = w; renderWins(); summary(); showErr(''); });
        winsBox.appendChild(b);
      });
    }
    renderWins();
    var pickBox = $('[data-v7tp-pickup]'), delBox = $('[data-v7tp-delivery]');
    $all('[data-v7tp-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.fulfil = b.getAttribute('data-v7tp-mode');
        $all('[data-v7tp-mode]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (pickBox) pickBox.hidden = S.fulfil !== 'pickup';
        if (delBox) delBox.hidden = S.fulfil !== 'delivery';
        if (S.date && isShut(S.date)) S.date = null; /* e.g. 1.11 is closed for delivery only */
        renderCal(); summary(); showErr('');
      });
    });
    $all('[data-v7tp-pk]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.butik = b.getAttribute('data-v7tp-pk');
        $all('[data-v7tp-pk]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        summary(); showErr('');
      });
    });
    var addrEl = $('[data-v7tp-address]');
    if (addrEl) addrEl.addEventListener('input', function () { S.address = addrEl.value; addrEl.classList.remove('is-bad'); summary(); });

    /* ---------- 7. details ---------- */
    [['name', '[data-v7tp-name]'], ['phone', '[data-v7tp-phone]'], ['email', '[data-v7tp-email]']].forEach(function (p) {
      var el = $(p[1]);
      if (el) el.addEventListener('input', function () { S[p[0]] = el.value; el.classList.remove('is-bad'); });
    });
    var invChk = $('[data-v7tp-inv]'), invBox = $('[data-v7tp-invbox]');
    if (invChk) invChk.addEventListener('change', function () { S.invoice = invChk.checked; if (invBox) invBox.hidden = !invChk.checked; });

    /* NIP -> company data (Biała Lista MF), same as the old wizard / the cart */
    function parseMfAddress(addr) {
      if (!addr) return null;
      addr = addr.replace(/\s+/g, ' ').trim();
      var ci = addr.lastIndexOf(','); if (ci === -1) return null;
      var streetPart = addr.slice(0, ci).trim();
      var zm = addr.slice(ci + 1).trim().match(/^(\d{2}-\d{3})\s+(.+)$/);
      if (!zm) return null;
      var toks = streetPart.split(' '), ni = -1;
      for (var i = 0; i < toks.length; i++) { if (/^\d/.test(toks[i])) { ni = i; break; } }
      return { street: ni === -1 ? streetPart : toks.slice(0, ni).join(' '), no: ni === -1 ? '' : toks.slice(ni).join(' '), zip: zm[1], city: zm[2].trim() };
    }
    var invEls = {
      nip: $('[data-v7tp-inv-nip]'), name: $('[data-v7tp-inv-name]'), street: $('[data-v7tp-inv-street]'),
      no: $('[data-v7tp-inv-no]'), zip: $('[data-v7tp-inv-zip]'), city: $('[data-v7tp-inv-city]')
    };
    var nipStatus = $('[data-v7tp-nipstatus]');
    function setNip(kind, text) {
      if (!nipStatus) return;
      nipStatus.hidden = !text;
      nipStatus.className = 'v7tp-nip' + (kind ? ' is-' + kind : '');
      txt(nipStatus, text || '');
    }
    var nipTimer = null, lastNip = '';
    function nipLookup(nip) {
      setNip('', T.nipLoad);
      fetch('https://wl-api.mf.gov.pl/api/search/nip/' + nip + '?date=' + isoDate(new Date()), { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var s = j && j.result && j.result.subject;
          if (!s) { setNip('err', T.nipNotFound); return; }
          if (s.name) { invEls.name.value = s.name; S.inv.name = s.name; invEls.name.classList.remove('is-bad'); }
          var p = parseMfAddress(s.workingAddress || s.residenceAddress || '');
          if (p) {
            invEls.street.value = p.street; S.inv.street = p.street;
            invEls.no.value = p.no; S.inv.no = p.no;
            invEls.zip.value = p.zip; S.inv.zip = p.zip;
            invEls.city.value = p.city; S.inv.city = p.city;
          }
          setNip('ok', s.name || T.nipOk);
        })
        .catch(function () { setNip('err', T.nipErr); });
    }
    if (invEls.nip) {
      invEls.nip.addEventListener('input', function () {
        var cleaned = (invEls.nip.value || '').replace(/\D/g, '').slice(0, 10);
        if (cleaned !== invEls.nip.value) invEls.nip.value = cleaned;
        S.inv.nip = cleaned;
        invEls.nip.classList.remove('is-bad');
        clearTimeout(nipTimer);
        if (!cleaned.length) { setNip('', ''); lastNip = ''; return; }
        if (cleaned.length === 10 && cleaned !== lastNip) {
          if (!isValidNip(cleaned)) { setNip('err', T.nipInvalid); lastNip = ''; return; }
          nipTimer = setTimeout(function () { lastNip = cleaned; nipLookup(cleaned); }, 350);
        }
      });
      ['name', 'street', 'no', 'zip', 'city'].forEach(function (k) {
        if (invEls[k]) invEls[k].addEventListener('input', function (e) { S.inv[k] = e.target.value; e.target.classList.remove('is-bad'); });
      });
    }

    /* ---------- send: same fields + body as the old wizard ---------- */
    function fld(name) { return document.querySelector('[data-v7tp-fld="' + name + '"]'); }
    function send() {
      if (uploading || !sendForm) return;
      var date = S.date ? isoDate(S.date) : '';
      var place = S.fulfil === 'pickup'
        ? 'Odbior w butiku: ' + S.butik
        : 'Dostawa: ' + S.address + ' | okno: ' + S.win;
      var photos = S.photos.join('\n') + (S.photoLink ? '\nLink: ' + S.photoLink : '');
      var body = [
        'ZAPYTANIE O TORT PERSONALIZOWANY (kreator)',
        'Okazja: ' + S.occasion,
        'Liczba porcji: ' + S.portions,
        'Smak: ' + S.flavour,
        'Styl: ' + (S.styles.join(', ') || '-'),
        'Opis pomyslu: ' + (S.desc || '-'),
        'Napis na torcie: ' + (S.inscription || '-'),
        'Zdjecia inspiracji: ' + (photos.trim() || '-'),
        'Termin: ' + date,
        place,
        'Faktura: ' + (S.invoice ? ('NIP ' + S.inv.nip + ' | ' + S.inv.name + ' | ' + (S.inv.street + ' ' + S.inv.no).trim() + ', ' + S.inv.zip + ' ' + S.inv.city) : 'nie'),
        '---',
        'Imie i nazwisko: ' + S.name,
        'Telefon: ' + S.phone,
        'E-mail: ' + S.email,
        'Jezyk klienta: ' + LOC
      ].join('\n');

      fld('email').value = S.email.trim();
      fld('name').value = S.name;
      fld('phone').value = S.phone;
      fld('occasion').value = S.occasion;
      fld('portions').value = S.portions;
      fld('flavour').value = S.flavour;
      fld('date').value = date;
      fld('place').value = place;
      fld('photos').value = photos.trim();
      fld('body').value = body;

      /* keep the summary for the thank-you view after Shopify's round trip */
      try {
        var keep = {};
        $all('[data-v7tp-sum]').forEach(function (b) { keep[b.getAttribute('data-v7tp-sum')] = b.textContent; });
        sessionStorage.setItem('v7tp-sum', JSON.stringify(keep));
      } catch (e) { /* private mode: fine */ }

      sending = true;
      btnNext.disabled = true;
      txt(btnNext, T.sending);
      sendArmed = true;
      if (typeof sendForm.requestSubmit === 'function') sendForm.requestSubmit();
      else sendForm.submit();
    }

    /* ---------- after Shopify's redirect: thank you ---------- */
    if (C.posted || /[?&]contact_posted=true/.test(window.location.search)) {
      try {
        var kept = JSON.parse(sessionStorage.getItem('v7tp-sum') || 'null');
        if (kept) Object.keys(kept).forEach(function (k) { var el = $('[data-v7tp-sum="' + k + '"]'); if (el) el.textContent = kept[k]; });
        sessionStorage.removeItem('v7tp-sum');
      } catch (e) { /* fine */ }
      go(7);
      dots.forEach(function (d) { d.classList.remove('is-cur'); d.classList.add('is-done'); });
      if (fill) fill.style.width = '100%';
      setTimeout(function () { root.scrollIntoView({ block: 'start' }); var dn = $('[data-v7tp-done]'); if (dn) { try { dn.focus({ preventScroll: true }); } catch (e) { /* */ } } }, 60);
      return;
    }

    /* ---------- go ---------- */
    setPor(MIN);
    summary();
    go(0);
    if (C.failed) showErr(T.errSend);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* theme editor re-renders the section */
  document.addEventListener('shopify:section:load', init);
})();
